/**
 * Default format to formar and unformat for currency mask
 */
const defaults = {
  prefix: ""
  , suffix: ""
  , thousands: "."
  , decimal: ","
  , precision: 2
};

/**
 * Applies a currency format to a given value, it could be a either a string or a number parameter
 * @param {number || string} input A given value to apply a currency format, it could be number or string
 * @param {object} opt A given format to convert the given input into a string with currency format
 */
function formatMoney(input, opt = defaults) {
  if (typeof input === "number") {
    input = input.toFixed(fixed(opt.precision));
  }
  let negative = input.indexOf("-") >= 0 ? "-" : "";
  let numbers = onlyNumbers(input);
  let currency = numbersToCurrency(numbers, opt.precision);
  let parts = toStr(currency).split(".");
  let integer = parts[0];
  let decimal = parts[1];
  integer = addThousandSeparator(integer, opt.thousands);
  return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix;
}

/**
 * Converts a currency format number to its equivalent float number
 * @param {string} input A string with currency format to be converted into a float number
 * @param {number} precision A given precision to turn a given string number to float
 * @returns {number} Returns a float number with precision and signed
 */
function unformatMoney(input, precision = 2) {
  let negative = input.indexOf("-") >= 0 ? -1 : 1;
  let numbers = onlyNumbers(input);
  let currency = numbersToCurrency(numbers, precision);
  return parseFloat(currency) * negative;
}

/**
 * Converts a given value to only numbres, replacing any type of character different of a number
 * @param {string} input Receives a value and tries to convert it to only numbers
 * @returns {string} Returns the string removing other characters different from numbers
 */
function onlyNumbers(input) {
  return toStr(input).replace(/\D+/g, "") || "0";
}

/**
 * Fix a number with a given precision
 * @param {number} precision The precision for the given
 * @returns {number} Returns a number fixed with a given precision
 */
function fixed(precision) {
  return between(0, precision, 20);
}

/**
 * ???
 * @param {*} min
 * @param {*} n
 * @param {*} max
 */
function between(min, n, max) {
  return Math.max(min, Math.min(n, max));
}

/**
 * Converts a string number into currency with a given precision
 * @param {string} numbers The numbers to turn into currency format
 * @param {number} precision The precision to fixed the given number and format it as currency
 * @returns {string} Returns the number converted as currency with the given precision
 */
function numbersToCurrency(numbers, precision) {
  let exp = Math.pow(10, precision);
  let float = parseFloat(numbers) / exp;
  return float.toFixed(fixed(precision));
}

/**
 * Adds a given separator for thousands for a given integer
 * @param {string} integer The integer number
 * @param {string} separator The separator for thousands for the given number
 * @returns {string} The given number separated with the given separator
 */
function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
}

/**
 * Composes a number formed by two parts, an integer and a decimal part
 * @param {string} integer The integer part of the composed number
 * @param {string} decimal The decimal part of the composed number
 * @param {string} separator The separator for the composed number, it defines the limit between the decimal and integer part
 * @returns {string} Returns a composed number by two parts, an integer and a decimal part
 */
function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer;
}

/**
 * Transforms a given value to string
 * @param {string} value The value to transform into string
 * @returns {string} Returns the value transformed to string
 */
function toStr(value) {
  return value ? value.toString() : "";
}

/**
 * Exports the format and unformat helper functions for the v-money library
 */
export { formatMoney, unformatMoney, addThousandSeparator };



// WEBPACK FOOTER //
// ./src/helpers/money-methods.js